<template>
  <Head title="Política de Devoluciones - Realgestion" />
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold text-darkblue-700 mb-6">Política de Devoluciones</h1>
    
    <div class="prose max-w-none">
      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">1. Condiciones de Devolución</h2>
      <p class="mb-4">
        Aceptamos devoluciones dentro de los 15 días posteriores a la compra. Los productos deben estar sin usar
        y en su empaque original.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">2. Proceso de Devolución</h2>
      <p class="mb-4">
        Para iniciar una devolución, contacte a nuestro servicio al cliente. Le proporcionaremos instrucciones
        detalladas sobre cómo proceder.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">3. Reembolsos</h2>
      <p class="mb-4">
        Los reembolsos se procesarán dentro de los 5 días hábiles posteriores a la recepción del producto devuelto.
        El reembolso se realizará mediante el método de pago original.
      </p>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import WebLayout from '@/Layouts/WebLayout.vue'

export default {
  layout: WebLayout,
  components: {
    Head
  }
}
</script> 